type MediaFrameProps = {
  /** 実際の画像URL。未指定の間はブランドトーンのプレースホルダーを表示する */
  src?: string;
  /** スマートフォン幅で切り替える画像URL（指定時は picture 要素でレスポンシブ切替） */
  srcMobile?: string;
  alt?: string;
  label?: string;
  note?: string;
  className?: string;
  tone?: "light" | "greige" | "dark";
  icon?: string;
  /** object-position（人物の見え方をページごとに調整するため）。md: 等を含むレスポンシブclass可 */
  objectPosition?: string;
  /** object-fit（既定はcover。文字まで含む完成バナーをクロップしたくない場合はcontain） */
  fit?: "cover" | "contain";
};

const toneClass: Record<string, string> = {
  light: "bg-gradient-to-br from-background-100 via-background-50 to-secondary-100",
  greige: "bg-gradient-to-br from-secondary-100 via-secondary-200/70 to-background-100",
  dark: "bg-gradient-to-br from-primary-700 via-primary-600 to-primary-800",
};

export default function MediaFrame({
  src,
  srcMobile,
  alt = "",
  label,
  note,
  className = "",
  tone = "light",
  icon = "ri-image-line",
  objectPosition,
  fit = "cover",
}: MediaFrameProps) {
  const isDark = tone === "dark";
  const fitClass = fit === "contain" ? "object-contain" : "object-cover";

  if (src) {
    return (
      <div className={`relative isolate overflow-hidden ${toneClass[tone]} ${className}`}>
        {srcMobile ? (
          <picture>
            <source media="(max-width: 767px)" srcSet={srcMobile} />
            <img
              src={src}
              alt={alt}
              title={alt}
              className={`absolute inset-0 h-full w-full ${fitClass} ${objectPosition ?? "object-top"}`}
            />
          </picture>
        ) : (
          <img
            src={src}
            alt={alt}
            title={alt}
            className={`absolute inset-0 h-full w-full ${fitClass} ${objectPosition ?? "object-top"}`}
          />
        )}
      </div>
    );
  }

  return (
    <div className={`relative isolate overflow-hidden ${toneClass[tone]} ${className}`}>
      <div
        aria-hidden
        className={`absolute inset-0 ${
          isDark ? "opacity-[0.12]" : "opacity-[0.35]"
        }`}
        style={{
          backgroundImage:
            "repeating-linear-gradient(135deg, rgba(255,255,255,0.0) 0px, rgba(255,255,255,0.0) 22px, rgba(36,35,33,0.05) 22px, rgba(36,35,33,0.05) 23px)",
        }}
      />
      <div
        className={`relative flex h-full w-full flex-col items-center justify-center text-center px-6 ${
          isDark ? "text-background-100/70" : "text-foreground-500"
        }`}
      >
        <span className="flex h-12 w-12 items-center justify-center rounded-full border text-xl">
          <i className={`${icon} text-2xl`} aria-hidden />
        </span>
        {label ? <span className="en-eyebrow mt-5 text-[10px] md:text-[11px]">{label}</span> : null}
        {note ? <span className="mt-2 text-[11px] tracking-wide">{note}</span> : null}
      </div>
    </div>
  );
}